import {
  checkAddCustomerEmail,
  checkConfirmCustomerEmails,
  checkFetchCustomerEmails,
  checkRemoveCustomerEmail,
  downloadCsvFileRequest,
  fetchAllWholesalerListRequest,
  fetchConceptsRequest,
  fetchContractsRequest,
  fetchEcommDataRequest,
  fetchFormDataRequest,
  fetchTemplateListRequest,
  getConceptsRequest,
  listCustomers as listCustomersRequest,
  logsRequest,
  reimportConceptsRequest,
  resendLinkRequest,
  resendLinkStatusCheck,
  resetUserRequest,
  searchUserRequest
} from '@cbgms/api/modules/customers/requests'
import { GETCompaniesResponse } from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { store } from '../../../../state/store'
import { any } from 'prop-types'
import { ResendLinkStatusResponse } from '@cbgms/api/modules/customers'
import { FiltrerAction, SelectedCustomerState } from './types'

export interface EcomPackage {
  ModuleID: string
  ModuleName: string
  Price: number
  AppID: string
}
export interface Email {
  Email: string
  Origin: string
  IsPrimary: boolean
}
export interface EcomPackagesResponse {
  Data: EcomPackage[]
}

export const listCustomers = (params: IPaginatedRequest) => {
  const currentState = store.getState()
  const emailAddress = currentState?.auth?.user?.email
  const role = currentState?.auth?.user?.['custom:role']
  const appid = currentState?.auth?.user?.['AppId']
  const ouName = currentState?.auth?.user?.['ou_name']
  const initialQuery = `Customer.OuName|=|${ouName}`
  params.search = params.search ? `${initialQuery},${params.search}` : initialQuery

  return AsyncAction<GETCompaniesResponse>({
    type: [types.GET_CUSTOMERS, types.GET_CUSTOMERS_SUCCESS, types.GET_CUSTOMERS_FAILED],
    payload: {
      api: 'support',
      request: listCustomersRequest(params, role, emailAddress, appid)
    }
  })
}
export const fetchLogsAction = (params: IPaginatedRequest) => {
  return AsyncAction({
    type: [types.GET_LOGS, types.GET_LOGS_SUCCESS, types.GET_LOGS_FAILED],
    payload: {
      api: 'support',
      request: logsRequest(params) // API request to fetch logs
    }
  })
}

export const searchCustomers = (data: any) => {
  const currentState = store.getState()
  const emailAddress = currentState?.auth?.user?.email
  const role = currentState?.auth?.user?.['custom:role']
  if (role !== 'dach_telesales') {
    data.SalesRep = ''
  } else {
    data.SalesRep = emailAddress
  }
  return AsyncAction<any>({
    type: [types.SEARCH_CUSTOMER, types.SEARCH_CUSTOMER_SUCCESS, types.SEARCH_CUSTOMER_FAILED],
    payload: {
      api: 'support',
      request: searchUserRequest(data)
    }
  })
}

export const getConcepts = (appId: number) => ({
  type: [types.GET_CONCEPTS, types.GET_CONCEPTS_SUCCESS, types.GET_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: getConceptsRequest(appId)
  },
  Data: []
})

export const UPDATE_QUERY = 'UPDATE_QUERY'
export const UPDATE_MODULE_ID = 'UPDATE_MODULE_ID'
export const UPDATE_ACTIVATION_STATUS = 'UPDATE_ACTIVATION_STATUS'
export const UPDATE_ECOMMERCE_STATUS = 'UPDATE_ECOMMERCE_STATUS'
export const RESET_FILTERS = 'RESET_FILTERS'
export const UPDATE_APP_ID = 'UPDATE_APP_ID'
export const UPDATE_OU_NAME = 'UPDATE_OU_NAME'
export function updateQuery(query: string): FiltrerAction {
  return { type: UPDATE_QUERY, payload: query }
}

export function updateModuleID(moduleID: string): FiltrerAction {
  if (moduleID === 'None') {
    moduleID = ''
  }
  return { type: UPDATE_MODULE_ID, payload: moduleID }
}

export function updateActivationStatus(status: string): FiltrerAction {
  if (status === 'None') {
    status = ''
  }
  return { type: UPDATE_ACTIVATION_STATUS, payload: status }
}

export function updateEcommerceStatus(status: string): FiltrerAction {
  if (status === 'None') {
    status = ''
  }
  return { type: UPDATE_ECOMMERCE_STATUS, payload: status }
}
export function updateAppId(appId: string): FiltrerAction {
  return { type: UPDATE_APP_ID, payload: appId }
}

export function updateOuName(ouName: string): FiltrerAction {
  return { type: UPDATE_OU_NAME, payload: ouName }
}
export function resetFilters(): FiltrerAction {
  return { type: RESET_FILTERS }
}

export const setSelectedCustomer = (customer: SelectedCustomerState | null): FiltrerAction => ({
  type: types.SET_SELECTED_CUSTOMER,
  payload: customer
})

export const clearSelectedCustomer = (): FiltrerAction => ({
  type: types.CLEAR_SELECTED_CUSTOMER
})

export const reimportConcepts = (
  appId: string,
  customerEosId: string,
  customerNumber: string,
  shipToLocation: string,
  OuName: string,
  userEmail: string
) => ({
  type: [types.REIMPORT_CONCEPTS, types.REIMPORT_CONCEPTS_SUCCESS, types.REIMPORT_CONCEPTS_FAILED],
  payload: {
    api: 'support',
    request: reimportConceptsRequest(appId, customerEosId, customerNumber, shipToLocation, OuName, userEmail)
  },
  Data: []
})

export const fetchCustomerEmails = (custEosId: string) => ({
  type: [types.FETCH_CUSTOMER_EMAILS, types.FETCH_CUSTOMER_EMAILS_SUCCESS, types.FETCH_CUSTOMER_EMAILS_FAILED],
  payload: {
    api: 'support',
    request: checkFetchCustomerEmails(custEosId)
  },
  Data: any
})

export const removeCustomerEmail = (custEosId: string, updatedEmails: any, App_Id: number) => ({
  type: [types.REMOVE_CUSTOMER_EMAIL, types.REMOVE_CUSTOMER_EMAIL_SUCCESS, types.REMOVE_CUSTOMER_EMAIL_FAILED],
  payload: {
    api: 'support',
    request: checkRemoveCustomerEmail(custEosId, updatedEmails, App_Id)
  },
  Data: any
})

export const confirmCustomerEmails = (custEosId: string, emails: any, App_Id: number) => ({
  type: [types.CONFIRM_CUSTOMER_EMAILS, types.CONFIRM_CUSTOMER_EMAILS_SUCCESS, types.CONFIRM_CUSTOMER_EMAILS_FAILED],
  payload: {
    api: 'support',
    request: checkConfirmCustomerEmails(custEosId, emails, App_Id)
  },
  Data: any
})

export const addCustomerEmail = (custEosId: string, newEmails: Email[], App_Id: number) => ({
  type: [types.ADD_CUSTOMER_EMAIL, types.ADD_CUSTOMER_EMAIL_SUCCESS, types.ADD_CUSTOMER_EMAIL_FAILED],
  payload: {
    api: 'support',
    request: checkAddCustomerEmail(custEosId, newEmails, App_Id)
  }
})
export const fetchEcommData = (extractedData: { CustEosID: string; OuName: string; AppId: string }) => {
  return AsyncAction<any>({
    type: [types.GET_ECOMM_DATA, types.GET_ECOMM_DATA_SUCCESS, types.GET_ECOMM_DATA_FAILED],
    payload: {
      api: 'support',
      request: fetchEcommDataRequest(extractedData) // Pass the entire object
    }
  })
}

export const fetchConcepts = (extractedConcept: { CustEosID: string; OuName: string; AppId: string }) => {
  return AsyncAction<any>({
    type: [types.GET_CONCEPTS_PROFILE, types.GET_CONCEPTS_PROFILE_SUCCESS, types.GET_CONCEPTS_PROFILE_FAILED],
    payload: {
      api: 'support',
      request: fetchConceptsRequest(extractedConcept) // Use the request function
    }
  })
}

export const fetchContracts = ({ CustEosId, AppId }: { CustEosId: string; AppId: string }) => {
  return AsyncAction<any>({
    type: [types.GET_CONTRACTS, types.GET_CONTRACTS_SUCCESS, types.GET_CONTRACTS_FAILED],
    payload: {
      api: 'support',
      request: fetchContractsRequest({ CustEosId, AppId })
    }
  })
}

export const resendLink = (custNo: string, shipToLoc: string, salesRepEmail: string, appId: number, CustomerEosId: string) => ({
  type: [types.RESENT_LINK, types.RESENT_LINK_SUCCESS, types.RESENT_LINK_FAILED],
  payload: {
    api: 'support',
    request: resendLinkRequest(custNo, shipToLoc, salesRepEmail, appId, CustomerEosId)
  },
  Data: {}
})

export const resendLinkStatus = (custEosid: string, appId: number) => {
  return AsyncAction<ResendLinkStatusResponse>({
    type: [types.CHECK_STATUS_FOR_RESENT_LINK, types.CHECK_STATUS_FOR_RESENT_LINK_SUCCESS, types.CHECK_STATUS_FOR_RESENT_LINK_FAILED],
    payload: {
      api: 'support',
      request: resendLinkStatusCheck(custEosid, appId)
    }
  })
}
export interface ResetUserResponse {
  Data: {
    Message: string
    Status: string
  }
}
export interface ResetUserResponseError {
  Error: string
  Data: {
    Message: string
    Status: string
  }
}
export const resetUser = (
  customerEosId: string,
  customerNumber: string,
  shipToLocation: string,
  ouName: string,
  appId: string | undefined,
  salesRepEmail: string
) =>
  AsyncAction<ResetUserResponse>({
    type: [types.RESET_USER, types.RESET_USER_SUCCESS, types.RESET_USER_FAILED],
    payload: {
      api: 'support',
      request: resetUserRequest({
        CustomerEosId: customerEosId,
        CustomerNumber: customerNumber,
        ShipToLocation: shipToLocation,
        OuName: ouName,
        AppId: appId,
        SalesRepEmail: salesRepEmail
      })
    }
  })

export const fetchAllWholesalerList = () => ({
  type: [types.GET_ALL_WHOLESALER, types.GET_ALL_WHOLESALER_SUCCESS, types.GET_ALL_WHOLESALER_FAILED],
  payload: {
    api: 'support',
    request: fetchAllWholesalerListRequest()
  },
  Data: []
})

export const fetchTemplateList = (wholesalerUUID: string) => ({
  type: [types.GET_TEMPLATE_LIST, types.GET_TEMPLATE_LIST_SUCCESS, types.GET_TEMPLATE_LIST_FAILED],
  payload: {
    api: 'support',
    request: fetchTemplateListRequest(wholesalerUUID)
  },
  Data: []
})

export const fetchFormData = (formDataUUID: string) => {
  return AsyncAction<any>({
    type: [types.FETCH_FORM_DATA, types.FETCH_FORM_DATA_SUCCESS, types.FETCH_FORM_DATA_FAILED],
    payload: {
      api: 'support',
      request: fetchFormDataRequest(formDataUUID)
    }
  })
}

export const downloadCsvFile = (selectedWholesaler: string, selectedTemplate: string) => {
  return AsyncAction<any>({
    type: [types.DOWNLOAD_CSV_FILE, types.DOWNLOAD_CSV_FILE_SUCCESS, types.DOWNLOAD_CSV_FILE_FAILED],
    payload: {
      api: 'support',
      request: downloadCsvFileRequest(selectedWholesaler, selectedTemplate)
    }
  })
}
